import React from 'react';

export default function Accessibility() {
  return (
    <div className="page">
      <div className="container" style={{ maxWidth: '860px', padding: '3rem 2rem' }}>
        <div className="page-header">
          <h1>Accessibility Statement</h1>
          <p>Last updated: May 27, 2026</p>
        </div>

        <div className="static-content">
          <section>
            <h2>Our Commitment</h2>
            <p>
              AstroA2Z is committed to ensuring digital accessibility for people of all abilities.
              We strive to continually improve the user experience for everyone and apply the relevant
              accessibility standards.
            </p>
          </section>

          <section>
            <h2>Standards</h2>
            <p>
              We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 at Level AA.
              These guidelines explain how to make web content more accessible for people with
              disabilities and more user-friendly for everyone.
            </p>
          </section>

          <section>
            <h2>Measures We Take</h2>
            <ul>
              <li>Semantic HTML structure for screen reader compatibility</li>
              <li>Sufficient color contrast ratios for text and interactive elements</li>
              <li>Keyboard-navigable interface</li>
              <li>ARIA labels on interactive components</li>
              <li>Alt text for informational images</li>
              <li>Responsive design supporting zoom up to 200%</li>
              <li>Focus indicators on interactive elements</li>
              <li>Multi-language support (English, Telugu, Hindi)</li>
            </ul>
          </section>

          <section>
            <h2>Known Limitations</h2>
            <p>
              While we strive for full accessibility, some areas may have limitations:
            </p>
            <ul>
              <li>Complex astrological charts (SVG-based) may not be fully screen-reader compatible — we provide text alternatives where possible</li>
              <li>Third-party embedded content may not meet our accessibility standards</li>
              <li>Some older content may not yet be fully accessible — we are progressively updating</li>
            </ul>
          </section>

          <section>
            <h2>Feedback</h2>
            <p>
              We welcome your feedback on the accessibility of AstroA2Z. If you encounter any
              barriers or have suggestions for improvement, please contact us:
            </p>
            <p>
              <strong>Email:</strong>{' '}
              <a href="mailto:accessibility@astroa2z.com">accessibility@astroa2z.com</a><br />
              <strong>Response Time:</strong> We aim to respond within 3 business days.
            </p>
          </section>

          <section>
            <h2>Legal</h2>
            <p>
              This statement is made in accordance with the Rights of Persons with Disabilities
              Act, 2016 (RPwD Act) and applicable accessibility guidelines issued by the Government
              of India.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
